import { z } from 'zod';

export const notificationSettingsSearchSchema = z.object({
    organizationId: z.string().optional(),
    unsubscribeEmailType: z.string().optional(),
    source: z.enum(['activity']).optional(),
    // Historical auto-disable notices still deep-link here.
    highlight: z.enum(['auto-cleanup']).optional(),
});
